export const environment = {
  production: false,
  appName: 'TriStar Finance',
  nmlsNumber: '43583',
  companyName: 'TriStar Finance',
  apiUrl: 'https://api.tristarfinance.com/api',
  turnstileSiteKey: '0x4AAAAAADmuUqg994QXeWV0',
  features: {
    enableBlog: true,
    enableCalculators: true,
    enableReviews: true
  }
};
